import React, {useEffect, useState} from 'react';
import {Event, PageView} from "../GoogleAnalytics";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Button from "react-bootstrap/Button";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import componentService from "../../services/components.service";
import {FormControl, Radio, RadioGroup} from "@mui/material";
import {ComponentGroupIdsEnum, SupportLevelIdsEnum} from "../../componentObjects";
import FormControlLabel from "@mui/material/FormControlLabel";
import hvacMakesService from "../../services/hvacmmakes.service";
import Select from "react-select";
import makeAnimated from "react-select/animated";
const animatedComponents = makeAnimated();

const MAKES_STR = "makes";
const MODELS_STR = "models";
const ID_STR = "id";
const DISPLAY_NAME_STR = "displayName";

const FULLY_SUPPORTED_STR = "FullySupported";
const PARTIALLY_SUPPORTED_STR = "PartiallySupported";
const NEEDS_MORE_INFO_STR = "NeedsMoreInfo";

const UnsupportedSourceList = ["https://highperformancehvac.com/hvac-manufacturers-brands-history/", "https://www.furnacecompare.com/mfr/", "https://www.house-energy.com/Furnaces/F-Manufacturers.htm"];

const otherOption = {
    id: -1,
    displayName: "Other"
}

function EquipmentValidation(props) {
    const { _isMounted, isLoading } = props;
    const [isMounted, setIsMounted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [makesList, setMakesList] = useState([]);
    const [modelsList, setModelsList] = useState([]);
    const [selectedMake, setSelectedMake] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);
    
    const [expanded, setExpanded] = useState(null);
    const [componentList, setComponentList] = useState([]);
    const [selectedComponents, setSelectedComponents] = useState([]);
    
    const [selectedInducer, setSelectedInducer] = useState(null);
    const [selectedIgnitionHeatSource, setSelectedIgnitionHeatSource] = useState(null);
    const [selectedGasValve, setSelectedGasValve] = useState(null);
    const [selectedBlower, setSelectedBlower] = useState(null);
    const [selectedCompressor, setSelectedCompressor] = useState(null);
    const [selectedCondenser, setSelectedCondenser] = useState(null);
    const [selectedEvaporator, setSelectedEvaporator] = useState(null);
    const [selectedExpansionValve, setSelectedExpansionValve] = useState(null);
    const [selectedReversingValve, setSelectedReversingValve] = useState(null);
    
    const [result, setResult] = useState(null);
    const [showResult, setShowResult] = useState(false);
    
    // populate info
    useEffect(() => {
        setIsMounted(true);
        setLoading(true);
        PageView();

        if (!isLoading) {
            populateMakeModelInfo();
            populateComponentInfo();
        }

        return () => {
            setIsMounted(false);
        };
    }, [isLoading]);
    
    const populateMakeModelInfo = () => {
        setMakesList([]);
        setModelsList([]);
        hvacMakesService.getmakesmodels()
            .then(response => {
                if (response !== null && response !== undefined) {
                    let makes = response[MAKES_STR];
                    if (makes !== null && makes !== undefined && makes.length) {
                        makes.push(otherOption);
                        setMakesList(makes);
                    }
                    let models = response[MODELS_STR];
                    if (models !== null && models !== undefined) {
                        models.push(otherOption);
                        setModelsList(models);
                    }
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
    
    const populateComponentInfo = () => {
        setComponentList([]);
        componentService.getall()
            .then(response => {
                setComponentList(response);
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
            });
    }
    
    // make model form
    
    const getOptionValue = (option) => {
        return option[ID_STR];
    }
    const getOptionLabel = (option) => {
        return option[DISPLAY_NAME_STR];
    }
    
    const onChangeMake = (selectedOption) => {
        setResult(null);
        setShowResult(false);
        setSelectedMake(selectedOption);
    }

    const onChangeModel = (selectedOption) => {
        setResult(null);
        setShowResult(false);
        setSelectedModel(selectedOption);
    }
    
    const onVerifyMakeModel = () => {
        let result = NEEDS_MORE_INFO_STR;
        
        if (selectedMake !== null && selectedMake !== otherOption && selectedModel !== null && selectedModel !== otherOption) {
            if (selectedModel.hvacMakeId !== selectedMake.id) {
                result = NEEDS_MORE_INFO_STR;
            }
            else if (selectedMake.source !== null && selectedMake.source !== "" && !UnsupportedSourceList.includes(selectedMake.source)) {
                result = FULLY_SUPPORTED_STR;
            }
        }
        
        setResult(result);
        setShowResult(true);
    }
    
    const onResetMakeModel = () => {
        setSelectedModel(null);
        setSelectedMake(null);
        setResult(null);
        setShowResult(false);
    }
    
    // component form
    
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };
    
    const handleChangeComponent = (selectedId, checked, compGroupId, setSelected) => {
        setResult(null);
        setShowResult(false);
        let compList = componentList;
        let selectedComps = selectedComponents;
        selectedComps = selectedComps.length ? selectedComps.filter(c => c.componentGroupId !== compGroupId) : [];
        if (checked) {
            setSelected(selectedId);
            selectedComps.push(compList.find(c => c.id.toString() === selectedId.toString()));
        }
        else {
            selectedComps = selectedComps.filter(i => i.id !== selectedId);
            setSelected(null);
        }
        console.log(selectedComps);
        setSelectedComponents(selectedComps);
    }
    
    const handleChangeInducer = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.Inducer, setSelectedInducer);
    }

    const handleChangeIgnitionHeatSource = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.Ignition_HeatSource, setSelectedIgnitionHeatSource);
    }
    
    const handleChangeGasValve = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.GasValve, setSelectedGasValve);
    }

    const handleChangeBlower = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.Blower, setSelectedBlower);
    }

    const handleChangeCompressor = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.Compressor, setSelectedCompressor);
    }

    const handleChangeCondenser = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.Condenser, setSelectedCondenser);
    }

    const handleChangeEvaporator = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.Evaporator, setSelectedEvaporator);
    }

    const handleChangeExpansionValve = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.ExpansionValve, setSelectedExpansionValve);
    }

    const handleChangeReversingValve = (e) => {
        handleChangeComponent(e.target.value, e.target.checked, ComponentGroupIdsEnum.ReversingValve, setSelectedReversingValve);
    }
    
    const onVerifyComponents = () => {
        let result = NEEDS_MORE_INFO_STR;
        if (selectedComponents !== null && selectedComponents !== undefined && selectedComponents.length) {
            if (selectedComponents.some(c => c.supportLevelId === SupportLevelIdsEnum.NeedsMoreInfo)) {
                result = NEEDS_MORE_INFO_STR;
            }
            else if (selectedComponents.some(c => c.supportLevelId === SupportLevelIdsEnum.Partially)) {
                result = PARTIALLY_SUPPORTED_STR
            }
            else if (selectedComponents.some(c => c.supportLevelId === SupportLevelIdsEnum.Fully)) {
                result = FULLY_SUPPORTED_STR;
            }
        }
        setResult(result);
        setShowResult(true);
    }
    
    const onResetComponents = () => {
        setSelectedComponents([]);
        setSelectedInducer(null);
        setSelectedIgnitionHeatSource(null);
        setSelectedGasValve(null);
        setSelectedBlower(null);
        setSelectedCompressor(null);
        setSelectedCondenser(null);
        setSelectedEvaporator(null);
        setSelectedExpansionValve(null);
        setSelectedReversingValve(null);
        setResult(null);
        setShowResult(false);
    }
    
    // result 
    const clearResult = () => {
        setResult(null);
        setShowResult(false);
    }
    
    const getResult = (result) => {
        let response = null;
        
        if (result === FULLY_SUPPORTED_STR) {
            response = <div className={"color-green result-icon"}>
                <i className="fa-solid fa-square-check result-icon margin-right-10"></i>
                Fully Supported
            </div>;
        } else if (result === PARTIALLY_SUPPORTED_STR) {
            response = <div className={"color-yellow result-icon"}>
                <i className="fa-solid fa-square-check result-icon margin-right-10"></i>
                Partially Supported
            </div>;
        }
        else {
            response = <div className={"color-red result-icon"}>
                <i className="fa-solid fa-circle-question result-icon margin-right-10"></i>
                Reach out to LifeWhere Tech Support for additional installation support.<br/> Contact us at proiqsupport@resideo.com or 855-539-4373, prompt 2 for LifeWhere.
            </div>;
        }
        
        return response;
    }
    
    // html
    
    let makeModelContent = <div className={"margin-30 pad-30 border text-left"}>
        <div className={"row"}>
            <div className={"col-6"}>
                <span className="sidebar-select-message select-message">Make</span>
                <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={makesList}
                    getOptionLabel={getOptionLabel}
                    getOptionValue={getOptionValue}
                    onChange={onChangeMake}
                    value={selectedMake}
                />
            </div>
        </div>
        <div className={"row margin-top-20"}>
            <div className={"col-6"}>
                <span className="sidebar-select-message select-message">Model</span>
                <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    options={modelsList}
                    getOptionLabel={getOptionLabel}
                    getOptionValue={getOptionValue}
                    onChange={onChangeModel}
                    value={selectedModel}
                />
            </div>
        </div>
        <div>
            <Button
                onClick={onVerifyMakeModel}
                className="invite-btn margin-top-25"
                disabled={selectedMake === null || selectedModel === null}
            >Verify</Button>

            <Button
                onClick={onResetMakeModel}
                className="reset-btn margin-top-25 margin-left-10"
                disabled={selectedMake === null && selectedModel === null}
            >Reset</Button>
        </div>
    </div>;
    
    let componentContent = <div className={"margin-30 pad-30 border text-left"}>
        <div className={"row"}>
            <div className="col-6 border-right">
                <div className={"margin-left-25 margin-right-25 pad-bottom-10 border-bottom"}>
                    <h5>Furnace/Air Handler Components</h5>
                </div>
                
                <div className={"margin-top-20"}>
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            Inducer
                        </AccordionSummary>
                        <AccordionDetails>

                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedInducer}
                                    onChange={handleChangeInducer}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.Inducer).map((item) => 
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                            
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                        >
                            Ignition/Heat Source
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedIgnitionHeatSource}
                                    onChange={handleChangeIgnitionHeatSource}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.Ignition_HeatSource).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                        >
                            Gas Valve
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedGasValve}
                                    onChange={handleChangeGasValve}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.GasValve).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4bh-content"
                            id="panel4bh-header"
                        >
                            Blower
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedBlower}
                                    onChange={handleChangeBlower}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.Blower).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                </div>
                
            </div>

            <div className="col-6">
                <div className={"margin-left-25 margin-right-25 pad-bottom-10 border-bottom"}>
                    <h5>AC/Heat Pump Components</h5>
                </div>

                <div className={"margin-top-20"}>
                    <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel5bh-content"
                            id="panel5bh-header"
                        >
                            Compressor
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedCompressor}
                                    onChange={handleChangeCompressor}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.Compressor).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel6bh-content"
                            id="panel6bh-header"
                        >
                            Condenser
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedCondenser}
                                    onChange={handleChangeCondenser}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.Condenser).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel7bh-content"
                            id="panel7bh-header"
                        >
                            Evaporator
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedEvaporator}
                                    onChange={handleChangeEvaporator}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.Evaporator).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel8bh-content"
                            id="panel8bh-header"
                        >
                            Expansion Valve
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedExpansionValve}
                                    onChange={handleChangeExpansionValve}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.ExpansionValve).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel9bh-content"
                            id="panel9bh-header"
                        >
                            Reversing Valve
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedReversingValve}
                                    onChange={handleChangeReversingValve}
                                >
                                    {componentList?.filter(c => c.componentGroupId === ComponentGroupIdsEnum.ReversingValve).map((item) =>
                                        (<FormControlLabel value={item.id} control={<Radio />} label={item.name} />))}
                                </RadioGroup>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                </div>
                
            </div>
        </div>
        
        <div>
            <Button
                onClick={onVerifyComponents}
                className="invite-btn margin-top-25"
                disabled={selectedComponents.length === 0}
            >Verify</Button>

            <Button
                onClick={onResetComponents}
                className="reset-btn margin-top-25 margin-left-10"
                disabled={selectedComponents.length === 0}
            >Reset</Button>
        </div>
    </div>;
    
    let resultContent = result !== null && showResult ?
        <div>{getResult(result)}</div>
        : null;
    
    return (
        <div className='infoPage'>
            <div className="row no-gutters">
                <div className="col">
                    <h2 className="pageTitle pageTitle-border-none" id="tabelLabel">
                        Equipment Validation
                    </h2>
                </div>
            </div>
            <div className={"text-center margin-top-50"}>
                <p>
                    Use this tool to verify the HVAC equipment that is supported by Resideo LifeWhere.<br/> Select either the make/model or the components present in the HVAC equipment system and click Verify.
                </p>
            </div>
            <div className={"margin-30 text-center"}>
                <Tabs>
                    <TabList>
                        <Tab onClick={() => clearResult()}>Make/Model</Tab>
                        <Tab onClick={() => clearResult()}>Components</Tab>
                    </TabList>

                    <TabPanel>
                        {makeModelContent}
                    </TabPanel>

                    <TabPanel>
                        {componentContent}
                    </TabPanel>
                </Tabs>
                <br/>
                <div>
                    {resultContent}
                </div>
            </div>
        </div>
    )
    
}
export default EquipmentValidation;